module.exports = __webpack_public_path__ + "static/img/zhongzhongka21.c02115c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhongzhongka21.png
// module id = dZIb
// module chunks = 16